import { LOGO_URL } from './assets';

/**
 * Quem assina os relatórios: o laboratório, com logo, CNPJ e responsável.
 *
 * UM LUGAR SÓ. Cada PDF montava o próprio cabeçalho — uns com a logo do
 * FIVPro, outros só com o nome — e o laboratório configurado teria que ser
 * ensinado a oito arquivos, que sairiam de sincronia no primeiro campo novo.
 *
 * O LABORATÓRIO É REGISTRADO, não passado. Os geradores de etapa são chamados
 * de dezenas de lugares com `(service, dados)`, e o app trabalha com um
 * laboratório por vez. Quem troca o laboratório (o FIVSystem, a área do
 * cliente) registra aqui, e todo relatório aberto depois sai com a cara dele.
 * O registro guarda `logo_url` já resolvida: daqui não se fala com o banco.
 */
let atual = null;

export const definirLaboratorioDoRelatorio = (laboratorio) => {
  atual = laboratorio || null;
};

export const laboratorioDoRelatorio = () => atual;

const esc = (v) => String(v ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** A logo do laboratório; sem ela, a do FIVPro, como sempre foi. */
export const logoDoRelatorio = () => atual?.logo_url || LOGO_URL();

/** "CNPJ 00.000.000/0001-00 · (31) 99999-0000 · Rua X, Cidade". Vazio se nada configurado. */
export const dadosDoLaboratorio = (lab = atual) =>
  [
    lab?.cnpj && `CNPJ ${lab.cnpj}`,
    lab?.telefone,
    lab?.endereco,
  ].filter(Boolean).map(esc).join(' · ');

/** "Responsável técnico: Fulano · CRMV-MG 1234". Vazio se não houver nome. */
export const responsavelDoLaboratorio = (lab = atual) => {
  if (!lab?.responsavel_tecnico) return '';
  // "CRMV-MG 1234" já vem com a sigla; "1234" sozinho ganha.
  const numero = lab.responsavel_crmv;
  const crmv = numero ? ` · ${/^crmv/i.test(numero) ? '' : 'CRMV '}${esc(numero)}` : '';
  return `Responsável técnico: ${esc(lab.responsavel_tecnico)}${crmv}`;
};

/**
 * O bloco da esquerda do cabeçalho: logo, nome e a linha de dados.
 *
 * `nome` é a reserva para quem já recebia o nome por parâmetro e roda antes de
 * haver laboratório registrado. `comLogoDoProduto: false` é para o relatório
 * de visita, que nunca levou a logo do FIVPro — quem assina ali é o
 * laboratório; sem logo dele, fica só o texto.
 */
export const identidadeDoLaboratorio = ({ nome, comLogoDoProduto = true } = {}) => {
  const nomeDoLab = atual?.name || nome || '';
  const logo = atual?.logo_url || (comLogoDoProduto ? LOGO_URL() : null);
  const dados = dadosDoLaboratorio();
  return `
    <div class="lab-id">
      ${logo ? `<img src="${esc(logo)}" class="logo" onerror="this.style.display='none'">` : ''}
      ${nomeDoLab || dados ? `<div class="lab-texto">
        ${nomeDoLab ? `<div class="lab-nome">${esc(nomeDoLab)}</div>` : ''}
        ${dados ? `<div class="lab-dados">${dados}</div>` : ''}
      </div>` : ''}
    </div>`;
};

/** Quem aparece no rodapé: o laboratório, ou o produto quando não há. */
export const assinaturaDoRodape = (nome) => esc(atual?.name || nome || 'FIV Manager');

/** A linha do responsável técnico, pronta para ir abaixo do rodapé. */
export const linhaDoResponsavel = () => {
  const rt = responsavelDoLaboratorio();
  return rt ? `<div class="lab-responsavel">${rt}</div>` : '';
};

export const CSS_LABORATORIO = `
  .lab-id { display: flex; align-items: center; gap: 10px; min-width: 0; }
  .lab-id .logo { height: 42px; max-width: 160px; object-fit: contain; }
  .lab-nome { font-size: 13px; font-weight: 700; color: #111; }
  .lab-dados { font-size: 10px; color: #64748b; margin-top: 2px; max-width: 360px; }
  .lab-responsavel { font-size: 10px; color: #64748b; }`;
